import { PageHeader } from '@folio/components';
import { DocumentsListBrokerageFirmModule } from '@folio/modules';
import { useQuery } from '@tanstack/react-query';
import { configControllerGetPublicTenantConfigQueryOptions } from 'korint-sdk';

export function MyDocuments() {
  const { data: brokerageFirmDocumentsList = [] } = useQuery({
    ...configControllerGetPublicTenantConfigQueryOptions(),
    select: data => data.brokerageFirmDocuments?.brokerageFirmDocumentsList,
  });

  return (
    <div className="flex flex-col gap-4">
      <PageHeader title="Mes documents" />
      <DocumentsListBrokerageFirmModule
        documentsList={brokerageFirmDocumentsList}
        title="Documents"
      />
    </div>
  );
}
